<script setup>
// Este layout não precisa de lógica de script,
// sua função é apenas estrutural e visual.
</script>

<template>
  <!-- <div class="onboarding-container"> -->
    
    <main class="onboarding-content">
      <!-- O componente WelcomeTrialPlus.vue será renderizado aqui pelo router -->
      <router-view></router-view>
    </main>
  <!-- </div> -->
</template>

<style scoped>
/* Estilos 'scoped' para não interferir com o resto da aplicação */
.onboarding-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start; /* Alinha o conteúdo no topo */
  min-height: 100vh;
  /* Cor de fundo suave do seu tema para uma transição agradável */
  background-color: #fefbf5; 
  padding: 2rem;
  box-sizing: border-box;
}

.onboarding-header {
  width: 100%;
  /* Largura máxima consistente com o conteúdo da tela de boas-vindas */
  max-width: 56rem; 
  margin-bottom: 2rem;
  display: flex;
  justify-content: flex-start; /* Alinha o logo à esquerda */
}

.logo {
  max-width: 100px;
  height: auto;
}

.onboarding-content {
  width: 100%;
}
</style>
